import { GET_RESTAURANTS_LOADING, GET_RESTAURANTS_ERROR, GET_RESTAURANTS_SUCCESS} from "../actions/types";

const defaultState = {
  restaurantList: null,
  loading: true,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_RESTAURANTS_SUCCESS: return { ...state, restaurantList: action.payload, loading: false };
    case GET_RESTAURANTS_LOADING: return { ...state, restaurantList: null, loading: true }
    case GET_RESTAURANTS_ERROR: return {...state, restaurantList: null, loading: false}
    default: return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/restaurants.reducer.js